import {isValidElement} from 'react';
import {message as Antmessage} from 'antd';
import {partial, isObject} from 'lodash/fp';
import {
    IconSuccessCircleO,
    IconInfoCircleO,
    IconCloseCircleO,
    IconFailCircleO
} from '@baidu/ee-icon/svg';
import Loading from '../Loading';
import styles from './index.less';

const MESSAGE_TYPE_TO_ICON = {
    success: <IconSuccessCircleO />,
    error: <IconCloseCircleO />,
    warning: <IconFailCircleO />,
    info: <IconInfoCircleO />,
    loading: <Loading />
};

/**
 * @param content
 * @returns {boolean} string | null | react.element
 */
const isElement = content => {
    if (!isObject(content)) {
        return true;
    }
    return isValidElement(content);
};

const getContent = content => {
    if (isElement(content)) {
        return {title: '', data: content};
    }
    return content;
};

const messageBuilder = (type, content, duration = 4.5) => {
    const overlayStyle = {maxWidth: `${content.maxWidth}px`};

    const {title = '', data = ''} = getContent(content);

    const contentNode = (
        <div className={title ? styles.richTextWrapper : styles.textWrapper}>
            <div className={title ? styles.richTitle : styles.title}>
                {title}
            </div>
            <div>
                {data}
            </div>
        </div>
    );

    const messageNode = (
        <div
            className={title ? styles.richMessage : styles.message}
            style={overlayStyle}
        >
            {MESSAGE_TYPE_TO_ICON[type]}
            {contentNode}
        </div>
    );

    return Antmessage[type](messageNode, duration);
};

// message.config & message.destroy
export default Object.assign({}, Antmessage, {
    success: partial(messageBuilder, ['success']),
    error: partial(messageBuilder, ['error']),
    warning: partial(messageBuilder, ['warning']),
    info: partial(messageBuilder, ['info']),
    loading: partial(messageBuilder, ['loading'])
});
